import { render } from "./ErrorBox.vue?vue&type=template&id=cb5acfdc&scoped=true"
import script from "./ErrorBox.vue?vue&type=script&lang=js"
export * from "./ErrorBox.vue?vue&type=script&lang=js"

import "./ErrorBox.vue?vue&type=style&index=0&id=cb5acfdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5acfdc"]])

export default __exports__